module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"row\"> <div class=\"col-md-7\"> <div class=\"ending-in\"> <span class=\"bank-account\"></span> ending in <strong>")
    ; __append(escapeFn( locals.last4 ))
    ; __append("</strong> </div> <dl class=\"inline-definition-list\"> <dt>Account Name:</dt> <dd>")
    ; __append(escapeFn( locals.bank_name ))
    ; __append("</dd><br> <dt>Status:</dt> <dd>")
    ; __append(escapeFn( locals.verified ? "Verified" : "Pending" ))
    ; __append("</dd><br> </dl> </div> <div class=\"col-md-5\"> ")
    ;  if(!locals.verified) { 
    ; __append(" <a class=\"verify_account btn btn-blue btn-block\">Verify Account</a> ")
    ;  } else { 
    ; __append(" <a href=\"#\" class=\"one-time-charge btn btn-blue btn-block\">One-Time Charge</a> ")
    ;  } 
    ; __append(" <a href=\"#\" class=\"remove_account btn btn-red btn-block\">Remove Account</a> </div> </div> <div class=\"recharge_settings\"></div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/bank_account_details.ejs
// module id = 826
// module chunks = 1